import {StaticCodeHighlighter} from "../../stem-core/ui/CodeEditor";
import {isString} from "../../stem-core/base/Utils";
import {formatJSON, formatXML} from "../misc/Formatting";
import type {ExtendedOptions} from "../../stem-core/ui/UIBase";

interface DashboardStaticTextOptions {
    // Whatever the caller has: setOptions stringifies anything that isn't already a string
    value?: any;
    // "json" or "xml" picks the formatter below, and doubles as the ace mode
    type?: string;
    // Show the payload as it arrived, without reformatting
    rawMode?: boolean;
}

export class DashboardStaticText extends StaticCodeHighlighter {
    // CodeEditor fixes its own options type and doesn't forward a type argument, so this is the
    // documented fallback. `value` is replaced rather than intersected - it widens from string.
    declare options: Omit<ExtendedOptions<StaticCodeHighlighter>, "value"> & DashboardStaticTextOptions;

    setOptions(options: this["options"]) {
        options = {
            fontSize: 15,
            minLines: 3,
            maxLines: 25,
            aceMode: options.type || "text",
            ...options,
        }
        if (!isString(options.value)) {
            options.value = JSON.stringify(options.value, null, 3);
            options.aceMode = "json";
        }
        if (options.type === "xml" && !options.rawMode) {
            options.value = formatXML(options.value);
        }
        // If json, all objects are formatted
        if (options.type === "json" && (!options.rawMode || !isString(options.value))) {
            options.value = formatJSON(options.value);
        }
        super.setOptions(options);
    }
}
